import { useEffect, useState } from 'react';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Fighter } from '../../../../corelogic/domain/models/fighter.model';
import {
  getFighters,
  getFightersLoading,
} from '../../../../corelogic/state/fighter/fighter.selector';
import { store } from '../../../../corelogic/state/store';

const fighters$: Observable<Fighter[] | null> = store.select(getFighters);
const loading$: Observable<boolean> = store.select(getFightersLoading);

export const useFighterState = () => {
  const [fighters, setFighters] = useState<Fighter[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fightersSub = fighters$
      .pipe(distinctUntilChanged())
      .subscribe((fighters) => setFighters(fighters || []));
    const loadingSub = loading$
      .pipe(distinctUntilChanged())
      .subscribe(setIsLoading);

    return () => {
      fightersSub.unsubscribe();
      loadingSub.unsubscribe();
    };
  }, []);

  return { fighters, isLoading };
};
